// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8428":"06da6004","8692":"06da6004"}[chunkId] + ".chunk.css";
};